module.exports = __webpack_public_path__ + "img/content-img-1.fe878732.jpg";